import * as Yup from 'yup'

export const isValidInteger = (number) => {
    try {
        const schema = Yup.number().integer()
        return schema.validateSync(number)
    } catch (error) {
        return false
    }
}